import React from 'react';
import '../blocks/ModernBlocks.css';

const CultureBlock = ({ data }) => {
  return (
    <section className="culture-section">
      <div className="culture-container">
        <div className="culture-header">
          <h2 className="culture-title">{data.title}</h2>
          <p className="culture-subtitle">{data.subtitle}</p>
        </div>
        <div className="culture-grid">
          {data.features.map((feature, index) => (
            <div key={index} className="culture-feature">
              <div className="culture-icon">{feature.icon}</div>
              <h3 className="culture-feature-title">{feature.title}</h3>
              <p className="culture-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CultureBlock; 